let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g5oqR")).then(() => parcelRequire('7SUl6'));